module.exports = __webpack_public_path__ + "media/images/emblems/Visp-Wappen-e63a7333482cb7da19c4854022f8b79a.png";